import { TransferReasonTypes } from "../Types";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import FormInput from "../../common/FormInput";
import * as Mui from "@mui/material";
import EmptyState from "../../../../../util/component/EmptyState";
import { Parser } from "../../../utils";

interface Props {
  tenderWinner?: TransferReasonTypes.TenderDetails;
}

const Tender = (props: Props) => {
  const t = useOperationTranslation();

  if (!props.tenderWinner)
    return (
      <Mui.Box textAlign={"center"}>
        <Mui.Typography variant="h6">
          {t("transferReason.messages.noTender")}
        </Mui.Typography>
      </Mui.Box>
    );

  return (
    <Mui.Box mb={2}>
      <Mui.Card>
        {Object.keys(props.tenderWinner).length > 0 && (
          <Mui.CardContent>
            <Mui.Grid
              container
              columns={12}
              alignItems="center"
              spacing={2.5}
              rowGap={4}
            >
              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceType"
                  label={t("transferReason.details.tab4.priceType")}
                  value={props.tenderWinner?.priceType || ""}
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceStartValidityDate"
                  label={t(
                    "transferReason.details.tab4.priceStartValidityDate"
                  )}
                  value={props.tenderWinner?.priceStartValidityDate || ""}
                  type="date"
                  disabled
                  fullWidth
                  inputFormat={"DD/MM/YYYY"}
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceEndValidityDate"
                  label={t("transferReason.details.tab4.priceEndValidityDate")}
                  value={props.tenderWinner?.priceEndValidityDate || ""}
                  type="date"
                  disabled
                  fullWidth
                  inputFormat={"DD/MM/YYYY"}
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceStartProvince"
                  label={t("transferReason.details.tab4.priceStartProvince")}
                  value={props.tenderWinner?.priceStartProvince || ""}
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceEndProvince"
                  label={t("transferReason.details.tab4.priceEndProvince")}
                  value={props.tenderWinner?.priceEndProvince || ""}
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceKmRangeFrom"
                  label={t("transferReason.details.tab4.priceKmRangeFrom")}
                  value={
                    props.tenderWinner?.priceKmRangeFrom !== undefined
                      ? props.tenderWinner?.priceKmRangeFrom
                      : ""
                  }
                  type="number"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceKmRangeTo"
                  label={t("transferReason.details.tab4.priceKmRangeTo")}
                  value={
                    props.tenderWinner?.priceKmRangeTo !== undefined
                      ? props.tenderWinner?.priceKmRangeTo
                      : ""
                  }
                  type="number"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceLoadIndex"
                  label={t("transferReason.details.tab4.loadIndex")}
                  value={
                    props.tenderWinner?.priceLoadIndex !== undefined
                      ? props.tenderWinner?.priceLoadIndex
                      : ""
                  }
                  type="number"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="carrierName"
                  label={t("transferReason.details.tab4.carrierName")}
                  value={props.tenderWinner?.carrierName || ""}
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="carrierAddress"
                  label={t("transferReason.details.tab4.carrierAddress")}
                  value={props.tenderWinner?.carrierAddress || ""}
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="carrierCity"
                  label={t("transferReason.details.tab4.carrierCity")}
                  value={props.tenderWinner?.carrierCity || ""}
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="approvalDatetime"
                  label={t("transferReason.details.tab4.approvalDateTime")}
                  value={props.tenderWinner?.approvalDatetime || ""}
                  type="date"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceIncreasePercentage"
                  label={t(
                    "transferReason.details.tab4.promoIncreasePercentage"
                  )}
                  value={
                    props.tenderWinner?.priceIncreasePercentage !== undefined
                      ? props.tenderWinner?.priceIncreasePercentage
                      : ""
                  }
                  type="number"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceIncreaseStartDate"
                  label={t(
                    "transferReason.details.tab4.promoIncreaseStartValidity"
                  )}
                  value={props.tenderWinner?.priceIncreaseStartDate || ""}
                  type="date"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="priceIncreaseEndDate"
                  label={t(
                    "transferReason.details.tab4.promoIncreaseEndValidity"
                  )}
                  value={props.tenderWinner?.priceIncreaseEndDate || ""}
                  type="date"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="price"
                  label={t("transferReason.details.tab4.price")}
                  value={
                    props.tenderWinner?.price !== undefined
                      ? `€ ${Parser.price(props.tenderWinner?.price)}`
                      : ""
                  }
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>

              <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <FormInput
                  name="finalPrice"
                  label={t("transferReason.details.tab4.finalPrice")}
                  value={
                    props.tenderWinner?.finalPrice !== undefined
                      ? `€ ${Parser.price(props.tenderWinner?.finalPrice)}`
                      : ""
                  }
                  type="text"
                  disabled
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
          </Mui.CardContent>
        )}
      </Mui.Card>
    </Mui.Box>
  );
};

export default Tender;
